import React from 'react';
import styles from './FileInput.module.css';
import Button from '../button/Button';

// FileInput 컴포넌트의 props 타입 정의
interface FileInputProps {
    label: string;      // 입력 필드의 레이블
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;  // 파일 선택 시 호출될 콜백
    value: File | null;  // 현재 선택된 파일 객체
    accept?: string;     // 허용되는 파일 타입 (선택적)
    error?: string;      // 에러 메시지 (선택적)
}

// 파일 업로드 컴포넌트
const FileInput: React.FC<FileInputProps> = ({
                                                 label,
                                                 onChange,
                                                 value,
                                                 accept = "image/*,.pdf",  // 기본값으로 이미지와 PDF 파일 허용
                                                 error
                                             }) => {
    // 숨겨진 파일 입력 요소에 대한 참조
    const inputRef = React.useRef<HTMLInputElement>(null);

    return (
        <div className={styles.container}>
            {/* 헤더 영역: 레이블과 허용되는 파일 형식 표시 */}
            <div className={styles.header}>
                {label && <label className={styles.label}>{label || ""}</label>}
                <label className={styles.extension}>{accept}</label>
            </div>

            {/* 파일 입력 래퍼 */}
            <div className={styles.inputWrapper}>
                {/* 선택된 파일명을 보여주는 읽기 전용 텍스트 입력 필드 */}
                <input
                    type="text"
                    className={`${styles.fileNameInput} ${error ? styles.error : ''}`}
                    value={value ? value.name : ''}  // 파일이 선택된 경우 파일명 표시
                    placeholder="No file chosen"      // 파일 미선택 시 표시될 텍스트
                    readOnly
                />

                {/* 파일 선택 버튼 영역 */}
                <div className={styles.buttonWrapper}>
                    <Button
                        type="button"
                        variant="primary"
                        size="medium"
                        onClick={() => inputRef.current?.click()}  // 버튼 클릭 시 숨겨진 파일 입력 트리거
                    >
                        등록
                    </Button>
                </div>

                {/* 실제 파일 입력 요소 (화면에서 숨김) */}
                <input
                    ref={inputRef}
                    type="file"
                    className={styles.hiddenInput}
                    onChange={onChange}
                    accept={accept}
                />
            </div>

            {/* 에러 메시지 표시 영역 */}
            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
};

export default FileInput;